import React, { FC } from 'react';
import { EmptyLayout } from 'layout/empty/empty';
import { WhatsappButton } from 'common/whatsapp-button/whatsapp-button';

export const CustomLayout: FC<{ body: React.ReactNode; disabledWhatsapp?: boolean; header: React.ReactNode }> = ({
  body,
  disabledWhatsapp = false,
  header,
}) => (
  <EmptyLayout>
    {header}
    <main className="h-full w-full overflow-auto p-4" id="main-body">
      {body}
    </main>
    <footer className="h-6 bg-primary w-full lg:block hidden" />
    {!disabledWhatsapp && <WhatsappButton />}
  </EmptyLayout>
);
